import React, { useState, useEffect, useRef } from 'react'
import classnames from 'classnames'
import {isDescendant} from "../../../utils/DomHelper";
import WindowEventHelper from "../../../lib/WindowEventHelper";

function CategoryItem({category, selected, onSelect, openChildrenId, onOpenChildrenId}) {
  const hasChildren = category.children && category.children.length > 0
  const openChildren = hasChildren && category.id === openChildrenId

  function handleMouseOver(e) {
    onOpenChildrenId(category.id)
  }

  return (
    <li className={classnames({"on": category.id === selected.id, "sub_open": openChildren})} onMouseOver={handleMouseOver}>
      <label className="lab_btn">
        {category.name}
        <input type="button" className="btn_g" value={category.label} onClick={e => onSelect(category)} />
        {hasChildren && <span className="ico_blog ico_arr" />}
      </label>

      {openChildren &&
        <CategoryList categories={category.children} selected={selected} onSelect={onSelect} />
      }
    </li>
  )
}


function CategoryList({categories, selected, onSelect}) {

  const [openChildrenId, setOpenChildrenId] = useState(null)

  return (
    <div className="layer_opt">
      <ul className="list_opt">
        {categories.filter(category => category.id !== 0).map((category, index) =>
          <CategoryItem
            key={index}
            category={category}
            selected={selected}
            onSelect={onSelect}
            openChildrenId={openChildrenId}
            onOpenChildrenId={setOpenChildrenId}
          />
        )}
      </ul>
    </div>
  )
}


export default function CategoryDetailForm({onFocus, onBlur, onChange}) {
  const categories = window.Config.blog.categories
  const root = useRef()

  const [open, setOpen] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState(categories[0])

  function handleWindowClick(e) {
    let target = e.target

    if (!isDescendant(root.current, target)) {
      setOpen(false)
      onBlur()
    }
  }

  function handleToggleOpen() {
    setOpen(!open)
    if (!open) {
      onFocus()
    } else {
      onBlur()
    }
  }

  function handleSelect(category) {
    onChange(9, category.id === -3 ? 0 : category.label)
    setSelectedCategory(category)
    setOpen(false)
    onBlur()
  }

  useEffect(() => {
    WindowEventHelper.add("click", handleWindowClick)
    return () => {
      WindowEventHelper.remove("click", handleWindowClick)
    }
  })

  return(
    <div ref={root} className={classnames("opt_menu opt_menu2", { "opt_open": open })}>
      <button type="button" className="btn_opt" onClick={handleToggleOpen}>
        { selectedCategory.name }
        <span className="ico_blog ico_open" />
      </button>

      <CategoryList
        categories={categories} selected={selectedCategory}
        onSelect={handleSelect}
      />
    </div>
  )
}
